import { type CompanyIconKey, normalizeCompanyIcon } from '@pcrm/shared/icons';
import {
  Antenna,
  Building2,
  Cable,
  Factory,
  Globe,
  type LucideIcon,
  Network,
  Phone,
  Radio,
  Router,
  SatelliteDish,
  Server,
  Signal,
  Store,
  Tv,
  Wifi,
  Zap,
} from 'lucide-react';

/**
 * Numele din `@pcrm/shared/icons` → componenta `lucide-react`.
 *
 * Maparea stă **aici**, nu în `shared`: `shared` e importat și de backend, care n-are ce
 * face cu componente React. Acolo e lista de nume, aici sunt componentele — aceeași
 * împărțire ca la permisiuni (cheile în `shared`, etichetele în `apps/crm`).
 *
 * Tabelul e `Record<CompanyIconKey, …>`, deci **un nume adăugat în listă și uitat aici nu
 * compilează**. Asta e toată garanția de care are nevoie randarea.
 */
const ICONS: Record<CompanyIconKey, LucideIcon> = {
  Building2,
  Antenna,
  Wifi,
  Router,
  Network,
  Server,
  SatelliteDish,
  Radio,
  Cable,
  Signal,
  Globe,
  Phone,
  Tv,
  Zap,
  Store,
  Factory,
};

/** Etichete pentru selectorul din formular. Fără ele, lista ar fi doar simboluri. */
const LABELS: Record<CompanyIconKey, string> = {
  Building2: 'Clădire',
  Antenna: 'Antenă',
  Wifi: 'Wi-Fi',
  Router: 'Router',
  Network: 'Rețea',
  Server: 'Server',
  SatelliteDish: 'Antenă satelit',
  Radio: 'Radio',
  Cable: 'Cablu',
  Signal: 'Semnal',
  Globe: 'Glob',
  Phone: 'Telefon',
  Tv: 'Televiziune',
  Zap: 'Energie',
  Store: 'Magazin',
  Factory: 'Fabrică',
};

export function companyIcon(key: string | null | undefined): LucideIcon {
  return ICONS[normalizeCompanyIcon(key)];
}

export function companyIconLabel(key: CompanyIconKey): string {
  return LABELS[key];
}

/** Iconul unei firme, la dimensiunea din liste și meniuri. */
export function CompanyIcon({ icon, className }: { icon: string | null; className?: string }) {
  const Icon = companyIcon(icon);
  return <Icon className={className ?? 'size-4 shrink-0'} />;
}
